<template>
  <div class="row service-bg">
    <div class="col">
      <div class="service-title">
        <span>Servicio:</span>
      </div>
      <div class="service-content">
        <span>{{ item.serviceName }}</span>
      </div>
    </div>
    <div class="col">
      <div class="service-title">
        <span>Costo:</span>
      </div>
      <div class="service-content">
        <span>{{ item.serviceCost | price }}</span>
      </div>
    </div>
    <div v-if="!disable" class="col-1 mr-2">
      <action-button
        :i="`fas ${action.icon}`"
        :variant="action.variant"
        @click="action.actionClick"
      >
        {{ action.name }}
      </action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  components: {
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      require: true,
      default: () => ({
        serviceName: '',
        serviceCost: 0,
      }),
    },
    disable: {
      type: Boolean,
      default: () => false,
    },
    action: {
      type: Object,
      require: true,
      default: () => ({
        name: 'Facturar',
        variant: 'outline-success',
        icon: 'fa-check',
        actionClick: () => {},
      }),
    },
  },
};
</script>

<style scoped>
.service-bg {
  background: #f7f7f7;
  border-radius: 5px;
  margin: 10px 0 0 0;
  padding: 15px;
}
.service-title {
  color: #727272;
  font: normal normal normal 14px/28px Lato;
  font-weight: 700;
}
.service-content {
  color: #11291b;
  font: normal normal normal 16px/20px Lato;
}
</style>
